import React from 'react';
import { withTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router';
import Modal from '../../../design-system/components/atoms/modal';
import { Images } from '../../../app-constants';
import ImageIcon from '../../../components/images/image-icon';
import { contactAdmin } from '../../contact-admin';
import Button from '../../../design-system/components/atoms/button';
import hasPermission from '../../access-control/has-permission';
import { Permissions } from '../../access-control/enums/permissions';

type PlanErrorManagerState = {
  showPlanPermissionModal: boolean;
  title: string;
  contents: string[];
  showButtons: boolean;
};

type PlanErrorManagerProps = RouteComponentProps & {
  bindActions: (...args: any[]) => any;
  t: (x: string) => string;
};

class PlanErrorManager extends React.Component<
  PlanErrorManagerProps,
  PlanErrorManagerState
> {
  constructor(props) {
    super(props);

    this.state = {
      showPlanPermissionModal: false,
      title: '',
      contents: [],
      showButtons: false,
    };

    this.showUpgradePlanModal = this.showUpgradePlanModal.bind(this);
    this.hidePlanPermissionModal = this.hidePlanPermissionModal.bind(this);

    const { bindActions } = this.props;

    bindActions(this.showUpgradePlanModal);
  }

  handleSubmit = () => {
    const { history } = this.props;

    this.setState({ showPlanPermissionModal: false });
    history.push('/billings/upgrade');
  };

  showUpgradePlanModal(
    title: string,
    contents: string[],
    showButtons: boolean,
  ) {
    this.setState({
      showPlanPermissionModal: true,
      title,
      contents,
      showButtons,
    });
  }

  hidePlanPermissionModal() {
    this.setState({ showPlanPermissionModal: false });
  }

  render() {
    const {
      showPlanPermissionModal,
      title,
      contents,
      showButtons,
    } = this.state;
    const { t } = this.props;

    return (
      <Modal
        show={showPlanPermissionModal}
        className="upgrade-plan-modal"
        titleContent={
          <div className="d-flex">
            <ImageIcon src={Images.InfoCircleYellow} />
            <div className="pl-2"> {title || t('labels.upgrade_required')}</div>
          </div>
        }
        onClose={this.hidePlanPermissionModal}
        onHide={this.hidePlanPermissionModal}
        onSubmit={this.handleSubmit}
        showCloseIcon={true}
        hideCancelButton={!showButtons}
        hideSubmitButton={!showButtons}
        cancelButtonText={t('labels.no')}
        cancelButtonVarient={Button.Variant.Outlined}
        submitButtonText={t('labels.upgrade')}
      >
        <div className="bs-modal-content">
          <div className="bs-modal-inner-content">
            {contents && (
              <div className="contents">
                {contents.map((content) => (
                  <>
                    <p
                      key={content}
                      className="bs-mb-20 bs-mt-15 bs-modal-inner-content__contents"
                    >
                      {content}
                    </p>
                  </>
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(withRouter(PlanErrorManager));
